import { IInputStatus, IStepStatus } from '../../../interface/progress.interface'
import { shortConversion } from '../../../lib/gtm/convrsion'
import { RootStore } from '../../rootStore'
import runActions from '../utils/api/runActions'
import getCurrentStepNumber from '../utils/getCurrentStepNumber'
import { closeTooltipStep } from '../utils/tooltip/tooltipHandler'

interface DataForNextConfig {
  pixel: null | string,
  utm: null | Object,
  step: null | number
  newStep: null | number
}

class NextStep {
  rootStore
  stepsSetting
  utm = null
  isFullSteps = false
  isCurrentStepNumber = false

  dataForNextConfig: DataForNextConfig = {
    pixel: null,
    utm: null,
    step: null,
    newStep: null
  }

  constructor(root: RootStore) {
    this.rootStore = root

    this.stepsSetting = root.StepsStore.stepsSetting
  }

  nextCurrentStep = async () => {
    try {
      const { StepsStore, ProgressStore } = this.rootStore
      const currentStep = StepsStore.currentStep
      //set pixel
      this.dataForNextConfig.step = StepsStore.currentStep
      console.log('step ->', this.dataForNextConfig.step)

      if (StepsStore.currentStep < StepsStore.stepsInputs?.length - 1) {
        this.checkAllValidate()
        // const [result, firstErrorName] = ProgressStore.nextStepStatus(
        //   StepsStore.currentStep
        // )

        // if (result) {
        //   const actions = StepsStore.stepsSetting[StepsStore.currentStep].actions || null
        //   console.log('actions', actions)
        //   if (actions) {
        //     await this.runActions(actions)
        //   } else {
        //     this.moveToNextStep()
        //   }
        // }

        // StepsStore.firstErrorName = firstErrorName
        console.log('closeTooltipStep', currentStep, StepsStore.tooltipStepNumber)
        if (currentStep === StepsStore.tooltipStepNumber) {
          closeTooltipStep(StepsStore)
        }

      }
    } catch (error) {
      this.handleNextStepError({
        error
      })
    }
  }

  checkAllValidate = async () => {
    console.log('checkAllValidate')
    const {
      validsAsync
    } = this.rootStore.StepsStore

    const requests = Object.values(validsAsync)
      .filter(request => request !== false)
      //@ts-ignore
      .map(request => request.promise);

    try {
      console.log('checkAllValidate 2')
      await Promise.all(requests);
    } catch (error) {
      console.error(error);
    }

    console.log('checkAllValidate 3')
    this.checkAllStatus();

  }

  checkAllStatus = async () => {
    console.log('checkAllStatus')
    const { StepsStore, ProgressStore } = this.rootStore
    const [result, firstErrorName] = ProgressStore.nextStepStatus(
      StepsStore.currentStep
    )
    if (result) {
      const actions = StepsStore.stepsSetting[StepsStore.currentStep].actions || null
      console.log('actions', actions)
      if (actions) {
        await this.runActions(actions)
      } else {
        this.moveToNextStep()
      }
      // this.moveToNextStep()
    }
    if (!result) {
      console.log('invalidInputs', { ...StepsStore.invalidInputs })
      StepsStore.firstErrorName = firstErrorName
      this.handleNextStepError({})
    }
  }

  runActions = async (actions: any) => {
    try {
      this.rootStore.StepsStore.isApiLoading = true
      const data = await this.makeApiRequest(actions)
      console.log('runActions data', data)
      // this.handleApiData(data)
    } catch (error) {
      console.log(error)
    } finally {
      this.rootStore.StepsStore.isApiLoading = false
    }
  }

  makeApiRequest = async (actions: any) => {
    console.log('makeApiRequest')
    //@ts-ignore
    const data = await runActions(
      this.rootStore.StepsStore.stepsStoreApi,
      actions,
      this.rootStore.StepsStore.values,
      this.rootStore.StepsStore.stepsInputs[this.rootStore.StepsStore.currentStep],
      this.rootStore.StepsStore.lff_uid,
    )
    console.log('makeApiRequest data', data, data.status)
    if (data?.status === false) {
      this.handleApiError(data)
    } else if (data) {
      this.handleApiSuccess(data)
      if (data?.isRedirect) {
        this.handleRedirect(data)
        return
      }
      console.log('makeApiRequest', data)
      this.moveToNextStep()
      // this.handleApiData(data?.data?.apiRequest)
    } else {
      this.handleApiError(data)
    }

    return data?.apiRequest
  }

  handleApiSuccess = (data: any) => {
    console.log('handleApiSuccess', data)
    if (data.utm) {
      // shortConversion(data.utm)
      // this.rootStore.StepsStore.utm = data.utm
      this.dataForNextConfig.utm = data.utm
    }

    if (data.token) {
      console.log()
      document.cookie = `token=${data.token}; expires=Thu, 01 Jan 2099 00:00:00 UTC;`;
      localStorage.setItem('token', data.token)
    }
    if (data.lff_uid) {
      localStorage.setItem('lff_uid', data.lff_uid)
      this.rootStore.StepsStore.lff_uid = data.lff_uid
    }



    if (data.apiRequest) {
      this.handleApiRequest(data.apiRequest)
    }

    // if (isFullForm) {
    //   this.rootStore.StepsStore.redirectButtonHandler()

    // } else {
    //   this.moveToNextStep()
    // }
  }

  handleApiError = (data: any) => {
    console.log('handleApiError')
    this.rootStore.StepsStore.apiErrors = {
      ...this.rootStore.StepsStore.apiErrors,
      ...data?.errors,
      ...data?.error?.error_data
    }
    this.rootStore.StepsStore.invalidInputs = {
      ...this.rootStore.StepsStore.invalidInputs,
      ...data?.errors,
      ...data?.error?.error_data
    }
    if (data?.error) {
      this.rootStore.StepsStore.invalidInputs.error = data?.error
      this.rootStore.StepsStore.apiErrors.error = data?.error
      // gtmError(data?.error)
    }
    this.handleNextStepError({isApi: true})

  }

  handleNextStepError = ({ error, isApi = false }: { error?: any, isApi?: boolean }) => {
    let errorStepNumber = 0
    const { StepsStore, ProgressStore } = this.rootStore
    const steps = StepsStore.stepsInputs
    const errors = StepsStore.invalidInputs
    console.log({ ...errors }, { ...steps })
    for (let i = 0; i < steps.length; i++) {
      const subarr = steps[i];
      for (let j = 0; j < subarr.length; j++) {
        const str = subarr[j];
        if (errors.hasOwnProperty(str)) {
          console.log('handleNextStepError', str)
          if (isApi) {
            ProgressStore.changeStatus(
              str,
              IInputStatus.apiError,
              i
            )
          }

          errorStepNumber = i;
          if (str === 'accept') {
            ProgressStore.changeStatus(
              str,
              IInputStatus.error,
              i
            )
          }
        }
      }
    }
    console.log('errorStepNumber', errorStepNumber)
    this.rootStore.StepsStore.currentStep = errorStepNumber
    console.error('Error while moving to next step:', error);
    this.rootStore.StepsStore.setNeedsToScroll(true)
    // дополнительные действия по обработке ошибки
  };

  handleApiRequest = (apiRequest: any) => {
    const { StepsStore } = this.rootStore
    console.log('handleApiRequest', apiRequest)
    let newValues = {
      ...this.rootStore.StepsStore.values,
      ...apiRequest,
    }

    Object.keys(newValues).forEach((key) => {
      if (key === 'accept') {
        newValues[key] = '1'
      } else if (newValues[key] === null) {
        newValues[key] = ''
      }
    })

    StepsStore.values = newValues
    this.rootStore.ProgressStore.checkAllInputsStatus(this.rootStore.StepsStore.values)
    const { currentStepNumber, isFullSteps } = getCurrentStepNumber({
      steps: StepsStore.stepsInputs,
      values: StepsStore.values,
      dependencies: StepsStore.dependenciesForCuurentStep
    })
    console.log('currentStepNumber ', currentStepNumber)
    this.isCurrentStepNumber = true
    StepsStore.currentStep = currentStepNumber
    if (isFullSteps) {
      this.isFullSteps = isFullSteps
    }
    this.rootStore.ProgressStore.baseStepsProgress(
      StepsStore.stepsInputs,
      StepsStore.stepsSetting,
      StepsStore.inputsData,
      StepsStore.values,
      StepsStore.currentStep,
      StepsStore.isOptions
    )
  }

  handleApiData = (data: any) => {
    if (data?.result) {
      // Обновляем значения полей
      this.rootStore.StepsStore.values = {
        ...this.rootStore.StepsStore.values,
        ...data.result,
      }
    }

    // Переходим на следующий шаг
    this.moveToNextStep()
  }

  moveToNextStep = () => {
    console.log('birthday.status-1', this.rootStore.ProgressStore.stepsProgress[1].inputs.birthday.status)
    const { StepsStore } = this.rootStore

    if (this.isFullSteps) {
      StepsStore.redirectButtonHandler()
      return
    }

    if (this.rootStore.StepsStore.currentStep < this.rootStore.StepsStore.stepsInputs.length - 1) {
      console.log('moveToNextStep')
      this.rootStore.ProgressStore.changeStepStatus(
        this.rootStore.StepsStore.currentStep,
        IStepStatus.success
      )
      let newCurrentStep
      if (this.isCurrentStepNumber) {
        newCurrentStep = this.rootStore.StepsStore.currentStep
      } else {
        newCurrentStep = this.rootStore.StepsStore.currentStep + 1
      }
      this.isCurrentStepNumber = false
      this.rootStore.ProgressStore.changeStepStatus(
        newCurrentStep,
        IStepStatus.current
      )
      console.log('birthday.status-2', this.rootStore.ProgressStore.stepsProgress[1].inputs.birthday.status)
      this.rootStore.ProgressStore.checkAllInputsStatus(this.rootStore.StepsStore.values)
      this.rootStore.StepsStore.currentStep = newCurrentStep
      console.log('birthday.status-3', this.rootStore.ProgressStore.stepsProgress[1].inputs.birthday.status)
      // this.rootStore.ProgressStore.setCurrentStep(this.currentStep)
      //this.rootStore.StepsStore.values = this.rootStore.ProgressStore.getValuesByStep(this.currentStep)
      this.rootStore.StepsStore.invalidInputs = {}
      this.rootStore.StepsStore.firstErrorName = ''
      this.rootStore.StepsStore.apiErrors = {}

      //this.rootStore.UIStore.scrollStepIntoView(this.currentStep)
    } else {
      //this.rootStore.UIStore.scrollToBottom()
    }

    this.dataForNextConfig.newStep = StepsStore.currentStep
    if (StepsStore.stepsStoreConfig?.nextStep) {
      StepsStore.stepsStoreConfig.nextStep(this.dataForNextConfig)
    }

    this.setDefaultDataForNextConfig()
    console.log('birthday.status-end', this.rootStore.ProgressStore.stepsProgress[1].inputs.birthday.status)

  }

  handleRedirect = async (data: any) => {
    const { StepsStore } = this.rootStore

    this.rootStore.StepsStore.showSpinner = true

    if (StepsStore.stepsStoreConfig?.nextStep) {
      StepsStore.stepsStoreConfig.nextStep(this.dataForNextConfig)
    }

    this.rootStore.RedirectButton.handleRedirect()

    this.setDefaultDataForNextConfig()

    // await finish(this.rootStore.StepsStore.lff_uid).then(() => {
    //   console.log('finish')

    //   // stop showing spinner
    //   //this.showSpinner = false
    // })
  }

  setDefaultDataForNextConfig = () => {
    this.dataForNextConfig = {
      pixel: null,
      utm: null,
      step: null,
      newStep: null,
    }
  }
}

export default NextStep